// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import TradesTable from './trades-table';
// assets
//

// ----------------------------------------------------------------------

export default function TechnicalTrades() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <TradesTable />
        </Container >
    );
}
